import React from 'react';
import Card from 'components/Card';
import Button from 'components/Button';
import StickyBox from 'components/StickyBox';
import { jsx as _jsx } from "react/jsx-runtime";
function EditorPageStickySaveButton(_ref) {
  var isDisabled = _ref.isDisabled,
    isLoading = _ref.isLoading,
    buttonText = _ref.buttonText,
    onClick = _ref.onClick;
  return /*#__PURE__*/_jsx(StickyBox, {
    placement: "bottom",
    borderRadius: "large",
    mt: "m",
    children: /*#__PURE__*/_jsx(Card, {
      px: "m",
      py: "s",
      display: "flex",
      justifyContent: "center",
      children: /*#__PURE__*/_jsx(Button, {
        variant: "primary",
        type: "submit",
        isDisabled: isDisabled,
        isLoading: isLoading,
        icon: "ok",
        onClick: onClick,
        children: buttonText
      })
    })
  });
}
export default EditorPageStickySaveButton;